import { UIComponentHandler, UIDataModel } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import * as React from 'react';
import { TuneSettingsComponentProps, TuneSettingsComponentState, TuneSettingsComponentHandler } from './tunesettingscomponent';
import { CallerSettingsComponent } from './callersettings/callersettingscomponent';
import { TimeSettingsComponent } from './timesettings/timesettingscomponent';
import { Strings } from '../../../../utils/resources/strings';
import { ImageLoaderComponent } from '../../../toolkit/imageloader/imageloadercomponent';
import { ImageLoaderCSSStyle } from '../../../toolkit/imageloader/imageloadercss';
import { TuneSettingImageLoaderCSSStyleImpl } from './tunesettingimageloader';
import { TimeBasedSettingForAllCallersDtoImpl } from '../../../../core/dto/timebasedsetting/timebasedsettingforallcallersdto';
import { TimeBasedSettingForSpecificCallerDtoImpl } from '../../../../core/dto/timebasedsetting/timebasedsettingforspecificcallerdto';
import { TimeBasedSettingForCallersGroupDtoImpl } from '../../../../core/dto/timebasedsetting/timebasedsettingforcallersgroupdto';
import { GroupDto } from '../../../../core/dto/listtones/groupdto';
import { TuneSettingsCSSStyle, TuneSettingsCSSStyleImpl } from './tunesettingscss';
import { ButtonComponent } from '../../../toolkit/button/buttoncomponent';
import { ConfirmRequestCancelButtonCSSStyleImpl } from '../../popup/confirmrequest/confirmrequestcancelbutoncss';
import { ConfirmRequestConfirmButtonCSSStyleImpl } from '../../popup/confirmrequest/confirmrequestconfirmbuttoncss';
import { PopUpWrapperComponent } from '../../popup/popupwrappercomponent';
import { AlertType } from '../../../toolkit/alert/alerttype';
import { AlertComponent } from '../../../toolkit/alert/alertcomponent';
import { LoaderWrapperComponent } from '../../popup/loaderwrappercomponent';
import { LoaderComponent } from '../../../toolkit/loader/loadercomponent';
import { UIComponentViewImpl } from '../../../toolkit/uicomponentview';
import './tune-settings-style.css';
import { SwitchComponent } from '../../../toolkit/switch/switchcomponent';
import { SwitchCSSStyleImpl } from '../../../toolkit/switch/switchcss';
import { ToneDto } from 'src/com/sixdee/crbtportal/core/dto/tonedto';

export class  TuneSettingsViewImpl extends UIComponentViewImpl<UIDataModel>
{
    // private playerComponent: PlayerComponent | null;
    // private initialStateOfTonePlaying: boolean;
    // private playerCSSStyle: PlayerComponentCSSStyle;
    switchComponent:SwitchComponent;
    private popUpComponent: PopUpWrapperComponent;
    private imageLoaderCSSStyle: ImageLoaderCSSStyle;
    private callerSettingsRef: CallerSettingsComponent | null;
    private tunesSettingsRef: TimeSettingsComponent | null;
    private CssStyle :TuneSettingsCSSStyle;
    private loaderWrapperComponent:LoaderWrapperComponent;

    constructor(context: BaseContext, handler: UIComponentHandler)
    {
        super(context, handler);
        this.imageLoaderCSSStyle = new TuneSettingImageLoaderCSSStyleImpl(context);
        // this.playerCSSStyle = new TuneSettingsPlayerCSSStyleImpl(context);
        this.CssStyle =  new TuneSettingsCSSStyleImpl(context);
    }

    bindHandlers()
    {
      this.onConfirmClick = this.onConfirmClick.bind(this);
      this.closePopup = this.closePopup.bind(this);
      this.showPopup = this.showPopup.bind(this);
      this.showShuffleFailurePopup = this.showShuffleFailurePopup.bind(this);
      this.closeShufflePopup = this.closeShufflePopup.bind(this);
      this.onSettingsSuccess = this.onSettingsSuccess.bind(this);
    //   this.onPlayClicked = this.onPlayClicked.bind(this);
    //   this.onStopClicked = this.onStopClicked.bind(this);
      this.onCloseButtonClick = this.onCloseButtonClick.bind(this);
      this.isShuffleOn = this.isShuffleOn.bind(this);
      this.showShuffleSuccessPopup = this.showShuffleSuccessPopup.bind(this);
       this.callApi = this.callApi.bind(this);
       this.getShuffleStatus = this.getShuffleStatus.bind(this);
     
    }

    
    draw(props: TuneSettingsComponentProps, state: TuneSettingsComponentState, cssStyle: TuneSettingsCSSStyle): JSX.Element
    {
        super.draw(props, state, cssStyle);
        return (
            <>
            {
                this.getWebView(props, state, cssStyle)
            }
          
            <PopUpWrapperComponent ref={(item: any) => this.popUpComponent = item} context={props.context}/>
            <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>
            </>
        );

    }

    getWebView(props: TuneSettingsComponentProps, state: TuneSettingsComponentState, cssStyle: TuneSettingsCSSStyle)
    {
        return (
            <div id="tune-settings-main">
            <div id="tune-settings-text-div">
                 <div id="tune-settings-text">
                    {props.context.getResources().getString(Strings.advance_setting)}
                </div>
                <div id="toggle-div" style={{}}>
                                    <label id="toggle-label" style={{}}>
                                        {this.getContext().getResources().getString(Strings.default_tone)}
                                    </label>
                                    <SwitchComponent ref={(item: any) => this.switchComponent = item} onChange={(e)=>this.isShuffleOn(e,state.toneDto)} style={new SwitchCSSStyleImpl(this.getContext())} isChecked={false} context={this.getContext()}/>
                </div>
              </div>
           <div id="tune-settings-inner-wrapper" style={this.CssStyle.getInnerWrapperCSSStyle()}>
             
               <div id="tune-settings-img-main">
                   <div id="tune-settings-img" style={this.CssStyle.getTuneImageDivCSSStyle()}>
                           <ImageLoaderComponent defaultImageName={"default_image.jpg"} imagePath={state.toneDto.getImgPath()} imageLoaderCSSStyle={this.imageLoaderCSSStyle} context={props.context}/> 
                           {/* <PlayerComponent playIconName={"play_black.svg"} pauseIconName={"pause_black.svg"} playerCSSStyle={this.playerCSSStyle} isPlaying={this.initialStateOfTonePlaying} onPlayClicked={this.onPlayClicked} onStopClicked={this.onStopClicked} ref={item=>this.playerComponent=item} context={this.getUIProps().context}/> */}
                           <div id="tune-settings-details" style={this.CssStyle.getTuneDetailsDivCSSStyle()}>
                               <label id="tune-settings-tonename" style={this.CssStyle.getTuneNameLabelCSSStyle()}>
                                   {state.toneDto.getToneName()}
                               </label>
                               <label id="tune-settings-artistname"  style={this.CssStyle.getArtistNameLabelCSSStyle()}>
                                   {state.toneDto.getArtistName()}
                               </label>
                           </div>  
                   </div>
               </div>
               <div id="tune-settings-settings-main">
                      
                    
                   <div style={this.CssStyle.getSettingWrapperDivCSSStyle()}>
                     
                       <div id="tune-settings-advance-content-main">

                                   <label style={this.CssStyle.getAdvanceContentLabelCSSStyle()}>
                                       {props.context.getResources().getString(Strings.select_to_whom_you_want_to_play_it)}
                                   </label>
                                   <div id="tune-settings-caller-settings">
                                       <CallerSettingsComponent isShuffleOn={props.isShuffleOn} onAddToShuffleSelected={this.getShuffleStatus} ref={(item: any)=>{this.callerSettingsRef = item;}} context={props.context}/>
                                   </div>
                       </div>
                       {state.isAddToShuffle === false &&
                              <div id="tune-settings-timer-settings">
                              <label style={this.CssStyle.getAdvanceTimeContentLabelCSSStyle()}>
                                  {props.context.getResources().getString(Strings.choose_date_time)}
                              </label>
                                  <TimeSettingsComponent ref={(item: any)=>{this.tunesSettingsRef = item;}} context={props.context}/>
                              </div>
                       }
                     
                    
                   </div>
                   <div id="tune-settings-button-row">
                           <div id="tune-settings-confirm-button" style={this.CssStyle.getConfirmButtonDivCSSStyle()}>
                           <ButtonComponent onClick={this.onConfirmClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.confirm)}/>

                           </div>
                           <div id="tune-settings-cancel-button">
                           <ButtonComponent onClick={this.onCloseButtonClick} style={new ConfirmRequestCancelButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.cancel)}/>

                           </div>
                       </div>
               </div>
           </div>
       </div>
        );
    }

    isShuffleOn(isShuffleOn:boolean,toneDto:ToneDto): void
    {
        console.log("-----tiger",isShuffleOn);
        // return this.switchComponent !== null && this.switchComponent.isChecked();
         (this.getUIComponentHandler() as TuneSettingsComponentHandler).isShuffleOn(isShuffleOn, toneDto);

    }
    
    showLoader()
    {
       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
    showShuffleSuccessPopup()
    {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getUIProps().context.getResources().getString(Strings.confirm)} alertMessage={this.getUIProps().context.getResources().getString(Strings.defaulttoneconfirm)} alertType={AlertType.AUTHENTICATE} onCloseButtonClick={this.closeShufflePopup} onClick={this.callApi} context={this.getUIProps().context}/>);
    }
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }
     closePopup()
    {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(false, <></>);
    }
    updateShuffleButton():void
    {
        
        this.switchComponent.updateShuffle();
    }
    getShuffleStatus(status:boolean){
        console.log("getShuffleStatus() invoked",status);
         (this.getUIComponentHandler() as TuneSettingsComponentHandler).addToShuflleSelected(status);
    }
    protected closeShufflePopup()
    {
        this.updateShuffleButton();
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(false, <></>);
    }
    onSettingsSuccess()
    {
        this.closePopup();

        (this.getUIProps() as TuneSettingsComponentProps).onSettingsSuccess();
    }
    callApi()
    {
        (this.getUIComponentHandler() as TuneSettingsComponentHandler).showShufflePopup();
    }
    showPopup(id:string,msg:string,type:AlertType):void
    {   
        if(type === AlertType.SUCCESS)
        {
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.onCloseButtonClick} onClick={this.onSettingsSuccess} context={this.getUIProps().context}/>);
        }   
        else
        {
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context}/>);
        }   
    }
    showShuffleFailurePopup(id:string,msg:string,type:AlertType):void
    {
        
      
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closeShufflePopup} onClick={this.closeShufflePopup} context={this.getUIProps().context}/>);
      
    }
    validate(): boolean
    {
        
        if(this.callerSettingsRef !== null && !this.callerSettingsRef.validate())
        {
            return false;
        }

        if(this.tunesSettingsRef !== null && !this.tunesSettingsRef.validate())
        {
            return false;
        }

        return true;
    }

    validateAllCallers():boolean{

        if(this.callerSettingsRef !== null && this.tunesSettingsRef !== null)
        {
            if(this.callerSettingsRef.getCallerSettingSelected() === this.getUIProps().context.getResources().getString(Strings.all_callers) &&
             (this.tunesSettingsRef.getCallerSettings() === this.getContext().getResources().getString(Strings.full_day)||this.tunesSettingsRef.getCallerSettings() === this.getContext().getResources().getString(Strings.select_time)) && this.tunesSettingsRef.getIntervalLength() === 0)
            { 
                this.showPopup("",this.getContext().getResources().getString(Strings.please_select_repeat),AlertType.WARN);
                return false;
            }
          
        }
        return true; 
        
    }
    getCallerSettingSelected(): string
    {
        if(this.callerSettingsRef !== null)
        {
            return this.callerSettingsRef.getCallerSettingSelected();
        }
        else
        {
            return this.getUIProps().context.getResources().getString(Strings.all_callers);
        }
    }

    getAllCallerSettingsData()
    {
        let timeBasedSettingForAllCallersDto = new TimeBasedSettingForAllCallersDtoImpl();
        timeBasedSettingForAllCallersDto.setToneId((this.getUIProps() as TuneSettingsComponentProps).toneDto.getId());

        this.tunesSettingsRef !== null && this.tunesSettingsRef.getCallerData(timeBasedSettingForAllCallersDto);

        return timeBasedSettingForAllCallersDto;
    }

    getAddToShuffleSettingsData()
    {
        let timeBasedSettingForAllCallersDto = new TimeBasedSettingForAllCallersDtoImpl();
        timeBasedSettingForAllCallersDto.setToneId((this.getUIProps() as TuneSettingsComponentProps).toneDto.getId());

        timeBasedSettingForAllCallersDto.setWeeklyDays([]);
        timeBasedSettingForAllCallersDto.setRepeatInterval(this.getContext().getResources().getString(Strings.full_day));
        timeBasedSettingForAllCallersDto.setTimeSettingSelected(this.getContext().getResources().getString(Strings.full_day));
        timeBasedSettingForAllCallersDto.setStartTimestamp(this.getUIProps().context.getResources().getString(Strings.default_start_time));
        timeBasedSettingForAllCallersDto.setEndTimestamp(this.getUIProps().context.getResources().getString(Strings.default_end_time));

        return timeBasedSettingForAllCallersDto;
    }

    getSpecialCallerSettingsData()
    {
        let timeBasedSettingForAllCallersDto = new TimeBasedSettingForSpecificCallerDtoImpl();
        timeBasedSettingForAllCallersDto.setToneId((this.getUIProps() as TuneSettingsComponentProps).toneDto.getId());

        this.callerSettingsRef !== null && this.callerSettingsRef.getSpecialCallerData(timeBasedSettingForAllCallersDto);
        this.tunesSettingsRef !== null && this.tunesSettingsRef.getCallerData(timeBasedSettingForAllCallersDto);

        return timeBasedSettingForAllCallersDto;
    }

    getCallerGroupSettingsData()
    {
        let timeBasedSettingForAllCallersDto = new TimeBasedSettingForCallersGroupDtoImpl();
        timeBasedSettingForAllCallersDto.setToneId((this.getUIProps() as TuneSettingsComponentProps).toneDto.getId());

        this.callerSettingsRef !== null && this.callerSettingsRef.getCallerGroupData(timeBasedSettingForAllCallersDto);
        this.tunesSettingsRef !== null && this.tunesSettingsRef.getCallerData(timeBasedSettingForAllCallersDto);

        return timeBasedSettingForAllCallersDto;

    }

    setGroupsData(groupsList: GroupDto[])
    {
        this.callerSettingsRef !== null && this.callerSettingsRef.setGroupsList(groupsList);
    }

    onCloseButtonClick():void
    {
        // (this.getUIProps() as TuneSettingsComponentProps).closePopup();
        (this.getUIComponentHandler() as TuneSettingsComponentHandler).onCancelClicked();
    }

    onConfirmClick():void
    {
        console.log("onconfirmclick");

        (this.getUIComponentHandler() as TuneSettingsComponentHandler).onConfirmedClicked();
    }

    // onPlayComplete(): void 
    // {
    //     this.initialStateOfTonePlaying = false;
    //     this.playerComponent !== null && this.playerComponent.onPlayComplete();
    // }i
   
    // onPlayStop(): void 
    // {
    //     this.initialStateOfTonePlaying = false;
    //     this.playerComponent !== null && this.playerComponent.onPlayStop();
    // }

    // private onPlayClicked(): void
    // {
    //     this.initialStateOfTonePlaying = true;
    //     this.getContext().getPlayerManager()
    //                 .startPlay((this.getUIState() as TuneSettingsComponentState).toneDto.getToneUrl(), this);
    // }

    // private onStopClicked(): void
    // {
    //     this.initialStateOfTonePlaying = false;

    //     this.getContext().getPlayerManager().stopPlay();
    // }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/tunesettings/tunesettingsview.tsx